export function isIE11() {
    return !!window.MSInputMethodContext && !!document.documentMode;
}
